/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.organizationModule')
  .controller('OrganizationRestrictionsController', [
    '$scope',
    '$timeout',
    '$translate',
    'Restangular',
    'BulbAuthService',
    'BulbBusyService',
    'BulbModalService',
    'AUTH',
    '_',
    OrganizationRestrictionsController,
  ]);


function OrganizationRestrictionsController(
  $scope,
  $timeout,
  $translate,
  Restangular,
  BulbAuthService,
  BulbBusyService,
  BulbModalService,
  AUTH,
  _,
) {
  const that = this;

  this.hasGrades = null;
  this.enabledGrades = {};
  this.containedGrades = [];
  this.restrictions = {};
  this.hasRunLoad = false;
  this.isUserOrgAdmin = BulbAuthService.currentUser.hasRole(AUTH.ROLES.ORGANIZATION_ADMIN);

  // The "long" property in the objects of this array are not shown to the user whatsoever on the front-end, it is
  // simply to conform to the structure of the DTO needed for the call to the backend.
  // Using a separate higher education key from the signup page in case there is a desire to abbreviate it also.
  this.grades = [{ long: 'PRESCHOOL', short: $translate.instant('organization_dashboard_preschool_letter') },
    { long: 'KINDERGARTEN', short: $translate.instant('organization_dashboard_kindergarten_letter') },
    { long: 'FIRST', short: '1' }, { long: 'SECOND', short: '2' },
    { long: 'THIRD', short: '3' }, { long: 'FOURTH', short: '4' },
    { long: 'FIFTH', short: '5' }, { long: 'SIXTH', short: '6' },
    { long: 'SEVENTH', short: '7' }, { long: 'EIGHTH', short: '8' },
    { long: 'NINTH', short: '9' }, { long: 'TENTH', short: '10' },
    { long: 'ELEVENTH', short: '11' }, { long: 'TWELFTH', short: '12' },
    { long: 'POSTGRADUATE', short: $translate.instant('grade_level_POSTGRADUATE') },
    { long: 'OTHER', short: $translate.instant('organization_dashboard_other_letters') },
    { long: 'UNASSIGNED', short: $translate.instant('grade_level_UNASSIGNED') }];

  // This function will enable or disable checkboxes throughout the grid based on the type of grades that are
  // returned from the query of the organization. It will establish default restrictions if there are no previous
  // restrictions present.
  function enableCheckboxes(organization) {
    BulbBusyService.showBusyDuring(Restangular.one('organizations', organization.id).customGET('gradeLevels')
      .then((gradesOnly) => {
        const gradesOnlyLength = gradesOnly.length;

        // We check for the existence of grades from the return of the query.
        if (gradesOnlyLength > 0) {
          that.hasGrades = true;
          for (let i = 0; i < gradesOnlyLength; i++) {
            that.containedGrades.push(gradesOnly[i]);
            that.enabledGrades[gradesOnly[i]] = _.cloneDeep($scope.defaultRestrictions);
          }

          // This means there are grade restrictions already made for some grades. So we should overwrite
          // them here, so we have the up-to-date grades.
          if (organization.gradeRestrictions !== null) {
            for (let j = 0; j < Object.keys(organization.gradeRestrictions).length; j++) {
              const currentGrade = Object.keys(organization.gradeRestrictions)[j];
              if (that.containedGrades.indexOf(currentGrade) !== -1) {
                that.enabledGrades[currentGrade] = organization.gradeRestrictions[currentGrade];
              }
            }
          }
        } else if (!organization.restrictions) {
          that.restrictions = _.cloneDeep($scope.defaultRestrictions);
        } else {
          that.restrictions = organization.restrictions;
        }

        that.checkIfAllCheckboxesAreStillActive(organization);
      }));
  }

  // Run enableCheckboxes initially here, and then run it once more when the settings page itself is loaded.
  enableCheckboxes($scope.currentRestrictedOrg);

  // This function was made to be able to be run to dynamically update the checkbox grid anytime an interaction with
  // it was made. This is mainly for the top row and first column of checkboxes. It should ONLY run if grades exist.
  this.checkIfAllCheckboxesAreStillActive = function () {
    if (!that.hasGrades) {
      return;
    }

    if ($scope.currentRestrictedOrg.type === 'SCHOOL') {
      $timeout(enableOrDisableCheckboxes);
    } else {
      enableOrDisableCheckboxes();
    }
  };

  /*
         * This function was made to enabled, or disable, the active checkboxes on the page. Basically, it will loop
         * through the available checkboxes and handle the functionality for the grade-specific checkboxes and the
         * restriction-specific checkboxes (first row and first column).
         */
  function enableOrDisableCheckboxes() {
    const restrictionCheckboxes = $(`.${$scope.currentRestrictedOrg.id}-main-restriction-checkbox`);
    const gradeCheckboxes = $(`.${$scope.currentRestrictedOrg.id}-main-grade-checkbox:not(:disabled)`);

    // Loop through the restriction checkboxes, and see if every grade is restricted that's not disabled.
    // If they all are, then change the status. If not, then also change the status.
    for (let i = 0; i < restrictionCheckboxes.length; i++) {
      const current = $(restrictionCheckboxes[i]);
      const currentRestriction = $(`[name="${$scope.currentRestrictedOrg.id}_${current.prop('name')
      }[]"]:not(:disabled)`);
      const restrictionObj = {
        totalItems: currentRestriction.length,
        numDisabled: 0,
        numEnabled: 0,
      };

      // We do not want the private profiles row of buttons to have any effect on things we're doing here.
      if (current.prop('name') !== 'privateProfilesEnabled') {
        for (let j = 0; j < currentRestriction.length; j++) {
          if ($(currentRestriction[j]).prop('disabled')) {
            restrictionObj.numDisabled++;
            restrictionObj.totalItems--;
          }

          if ($(currentRestriction[j]).prop('checked')) {
            restrictionObj.numEnabled++;
          }
        }

        // We first check if the checkbox itself needs to be disabled.
        if (restrictionObj.totalItems === 0) {
          current.prop('checked', false);
          current.prop('disabled', true);
        } else if (restrictionObj.totalItems > 0) {
          current.prop('disabled', false);

          if (restrictionObj.numEnabled === restrictionObj.totalItems) {
            current.prop('checked', true);
          } else {
            current.prop('checked', false);
          }
        }
      }
    }

    // Loop through the grade checkboxes, and see if every checkbox is enabled. So we can handle both checkboxes
    // simultaneously.
    for (let k = 0; k < gradeCheckboxes.length; k++) {
      const currentEle = $(gradeCheckboxes[k]);
      const currentGrade = $(`.${$scope.currentRestrictedOrg.id}-${currentEle.prop('name')}-checkbox`)
        .not(`[name="${$scope.currentRestrictedOrg.id}_privateProfiles[]"]`);
      const gradeObj = {
        totalItems: currentGrade.length,
        numDisabled: 0,
        numEnabled: 0,
      };

      for (let l = 0; l < currentGrade.length; l++) {
        if ($(currentGrade[l]).prop('disabled')) {
          gradeObj.numDisabled++;
          gradeObj.totalItems--;
        }

        if ($(currentGrade[l]).prop('checked')) {
          gradeObj.numEnabled++;
        }
      }

      // We first check if the checkbox itself needs to be disabled.
      if (gradeObj.totalItems === 0) {
        currentEle.prop('checked', false);
        currentEle.prop('disabled', true);
      } else if (gradeObj.totalItems > 0) {
        currentEle.prop('disabled', false);

        if (gradeObj.numEnabled === gradeObj.totalItems) {
          currentEle.prop('checked', true);
        } else {
          currentEle.prop('checked', false);
        }
      }
    }
  }

  // This function is used to disable checkboxes initially when the table is loaded depending on the "private profiles"
  // toggle. It needs to disable the public publishing/private links checkboxes if it's enabled.
  function initialCheckboxDisabling() {
    that.containedGrades.forEach((gradeLevel) => {
      const identifierString = `.${$scope.currentRestrictedOrg.id}-${gradeLevel}-checkbox`;
      const privateProfileStatus = jQuery(`${identifierString}[restriction="privateProfilesEnabled"]`).prop('checked');

      if (privateProfileStatus) {
        jQuery(`${identifierString}[restriction="publicPublishing"]`).attr('disabled', true);
        jQuery(`${identifierString}[restriction="privateLinks"]`).attr('disabled', true);
        jQuery(`${identifierString}[restriction="socialSharing"]`).attr('disabled', true);
      }
    });
  }

  /*
         * This is the dual-purpose checkbox functionality code. If grades exist, it needs to check all of the checkboxes
         * in that row. If they do not exist, it needs to act as the checkbox that handles enabling org-wide
         * restrictions instead of specific grade-checkboxes.
         *
         * @param org the organization that we're handling.
         * @param e the event of the action so we can grab the element.
         * @param type the type of the row/column being effected.
         * @param restriction the name of the restriction being applied.
         */
  this.handleDualPurposeCheckbox = function (org, e, type, restriction) {
    const currentStatus = jQuery(e.currentTarget).prop('checked');
    const currentGrade = jQuery(e.currentTarget).prop('name');

    const privateProfilesStatus = jQuery(`.${org.id}-${currentGrade}-checkbox[restriction="privateProfilesEnabled"]`).prop('checked');

    // Type will be undefined if the checkbox is a grade-level one.
    if (type === undefined) {
      const currentColumn = jQuery(`.${org.id}-${currentGrade}-checkbox`);

      // We have to update the model directly here since updating the "checked" property using jQuery
      // does not update the ng-model value even after a digest.
      // eslint-disable-next-line array-callback-return
      _.mapValues(that.enabledGrades[currentGrade], (e) => {
        for (const i in e) {
          if (i !== 'maxPublishedPages') {
            if (i === 'publicPublishing' || i === 'privateLinks') {
              if (privateProfilesStatus) {
                e[i] = false;
                continue;
              }
            }

            e[i] = currentStatus;
          }
        }
      });
      // Change all of the checkboxes to the same status.
      currentColumn
        .not(`[name="${$scope.currentRestrictedOrg.id}_privateProfiles[]"]`)
        .not(':disabled')
        .prop('checked', currentStatus);
      that.checkIfAllCheckboxesAreStillActive($scope.currentRestrictedOrg);
    } else {
      if (!that.hasGrades) {
        // We need to test for the difference between publishing and sharing here, mainly because
        // there isn't an eloquent way to handle differentiating between publishing/sharing due to the way
        // the DTO needs to be structured.
        if (restriction === 'publishing' && that.restrictions.publishing[type]) {
          that.restrictions.publishing[type] = false;
        } else if (restriction === 'publishing' && !that.restrictions.publishing[type]) {
          that.restrictions.publishing[type] = true;
        }

        if (restriction === 'sharing' && that.restrictions.sharing[type]) {
          that.restrictions.sharing[type] = false;
        } else if (restriction === 'sharing' && !that.restrictions.sharing[type]) {
          that.restrictions.sharing[type] = true;
        }

        if (restriction === '' && that.restrictions[type]) {
          that.restrictions[type] = false;
        } else if (restriction === '' && !that.restrictions[type]) {
          that.restrictions[type] = true;
        }
      } else {
        // We have to update the model directly here since updating the "checked" property using jQuery
        // does not update the ng-model value even after a digest.
        for (let i = 0; i < Object.keys(that.enabledGrades).length; i++) {
          const gradeObj = that.enabledGrades[Object.keys(that.enabledGrades)[i]];

          if (restriction === '') {
            gradeObj[type] = currentStatus;
          } else {
            if (type === 'publicPublishing' || type === 'privateLinks') {
              if (gradeObj.privateProfilesEnabled) {
                gradeObj[restriction][type] = false;
                continue;
              }
            }

            gradeObj[restriction][type] = currentStatus;
          }
        }

        // Change all checkboxes to the same status.
        const checkboxes = $(`[name="${$scope.currentRestrictedOrg.id}_${
          type}[]"]:not(:disabled)`);
        checkboxes.prop('checked', currentStatus).trigger('input');
      }

      // Check if the checkboxes are still active here!
      that.checkIfAllCheckboxesAreStillActive($scope.currentRestrictedOrg);
    }
  };

  // Search for the available publishing controls only once here in this timeout, rather than searching for them
  // every time the function handlePrivateProfiles() below is called.
  let publicPublishingControls; let privateLinkControls; let
    socialSharingControls;
  $timeout(() => {
    publicPublishingControls = jQuery(`#${$scope.currentRestrictedOrg.id}_publishToPublic`)
      .parent().parent()
      .find('input:not(:disabled)');
    privateLinkControls = jQuery(`#${$scope.currentRestrictedOrg.id}_createPrivateLinks`)
      .parent().parent()
      .find('input:not(:disabled)');
    socialSharingControls = jQuery(`#${$scope.currentRestrictedOrg.id}_shareToSocial`)
      .parent().parent()
      .find('input:not(:disabled)');
  });

  /*
         * This is used to handle when someone clicks the private profile row of buttons, and how the click should
         * interact with the rest of the interface the user is seeing.
         *
         * @param e the event of the action so we can grab the element.
         * @param isDualPurpose this is whether or not the checkbox clicked was a dual-purpose one or not.
         * @param grade the grade level of the checkbox being clicked (can be undefined).
         */
  this.togglePrivateProfilesCheckbox = function (e, isDualPurpose, grade) {
    const privateProfilesCheckbox = jQuery(e.currentTarget);

    if (privateProfilesCheckbox.prop('checked')) {
      // Conditional: If we're toggling private profiles to true.
      const modalOptions = {
        titleCode: 'private_profiles_modal_title',
        bodyCode: 'private_profiles_modal_description',
        okButtonCode: 'private_profiles_modal_button_text',
        showCancelButton: true,
      };

      BulbModalService.show(modalOptions).then(() => {
        // If grade is undefined, it means that we're working with a dual purpose checkbox.
        if (isDualPurpose) {
          that.handleDualPurposeCheckbox($scope.currentRestrictedOrg, e, 'privateProfilesEnabled', '');
        }
        checkPrivateProfilesCheckbox(e, isDualPurpose, grade);
      }, () => {
        privateProfilesCheckbox.prop('checked', false);
        uncheckPrivateProfilesCheckbox(isDualPurpose, grade);
      });
    } else {
      uncheckPrivateProfilesCheckbox(isDualPurpose, grade);
    }

    // Regardless of what we do, check to see if the checkboxes need to remain active.
    that.checkIfAllCheckboxesAreStillActive();
  };

  /*
     * This is a helper function for the togglePrivateProfilesCheckbox function, this function will only
     * hit if the checkbox is toggled to an "off" state, OR if the user chooses not to enable Private Profiles
     * from the modal.
     */
  function uncheckPrivateProfilesCheckbox(isDualPurpose, grade) {
    if (!that.hasGrades) {
      that.restrictions.privateProfilesEnabled = false;
      publicPublishingControls.attr('disabled', false);
      privateLinkControls.attr('disabled', false);
      socialSharingControls.attr('disabled', false);
    } else {
      // This conditional determines if the user hit a single grade checkbox, or the checkbox that effects
      // the row of checkboxes.
      if (isDualPurpose) {
        publicPublishingControls.attr({ checked: false, disabled: false });
        privateLinkControls.attr({ checked: false, disabled: false });
        socialSharingControls.attr({ checked: false, disabled: false });
      } else {
        jQuery.each(
          $(`.${$scope.currentRestrictedOrg.id}-${grade}-checkbox`),
          (index, value) => {
            const $value = jQuery(value);

            if ($value.attr('name').includes('publicPublishing')
                || $value.attr('name').includes('privateLinks')
                || $value.attr('name').includes('socialSharing')) {
              $value.attr({ checked: false, disabled: false });
            }
          },
        );
      }
    }
  }

  /*
     * This is a helper function for the togglePrivateProfilesCheckbox function for when the checkbox
     * is actually checked. It will go through and disable the private links & public publishing checkboxes,
     * as well as check the appropriate boxes.
     *
     * @param e the event of the action so we can grab the element.
     * @param isDualPurpose this is whether or not the checkbox clicked was a dual-purpose one or not.
     * @param grade the grade level of the checkbox being clicked (can be undefined).
     */
  function checkPrivateProfilesCheckbox(e, isDualPurpose, grade) {
    // If we don't have grades, don't worry about anything... just toggle public publishing and private links.
    if (!that.hasGrades) {
      publicPublishingControls.attr({ checked: false, disabled: true });
      privateLinkControls.attr({ checked: false, disabled: true });
      socialSharingControls.attr({ checked: false, disabled: true });

      that.restrictions.publishing.publicPublishing = false;
      that.restrictions.sharing.privateLinks = false;
      that.restrictions.sharing.socialSharing = false;
    } else {
      // This conditional determines if the user hit a single grade checkbox, or the checkbox that effects
      // the row of checkboxes.
      if (isDualPurpose) {
        for (let i = 0; i < Object.keys(that.enabledGrades).length; i++) {
          const currentGrade = that.enabledGrades[Object.keys(that.enabledGrades)[i]];

          currentGrade.publishing.publicPublishing = false;
          currentGrade.sharing.privateLinks = false;
          currentGrade.sharing.socialSharing = false;
        }

        publicPublishingControls.attr({ checked: false, disabled: true });
        privateLinkControls.attr({ checked: false, disabled: true });
        socialSharingControls.attr({ checked: false, disabled: true });
      } else {
        that.enabledGrades[grade].sharing.privateLinks = false;
        that.enabledGrades[grade].sharing.socialSharing = false;
        that.enabledGrades[grade].publishing.publicPublishing = false;

        jQuery.each(
          $(`.${$scope.currentRestrictedOrg.id}-${grade}-checkbox`),
          (index, value) => {
            const $value = jQuery(value);

            if ($value.attr('name').includes('publicPublishing')
                || $value.attr('name').includes('privateLinks')
                || $value.attr('name').includes('socialSharing')) {
              $value.attr('checked', false);
              $value.attr('disabled', true);
            }
          },
        );
      }
    }
  }

  // This function will help determine if a grade level exists in the data.
  this.isGradeEnabled = function (grade) {
    return that.containedGrades.indexOf(grade) !== -1;
  };

  /**
     * Utility method
     * if hasGrades alter school
     * else alter org
     * @param org
     */
  this.setRestrictions = function (org) {
    let organizationDTO = {};
    let schoolDTO = {};
    // This means that it's an org/school-wide setting.
    if (!that.hasGrades) {
      // This is the top org, not a school belonging to it.
      if (org.id === $scope.topOrg.id) {
        organizationDTO = {
          restrictions: that.restrictions,
        };
        BulbBusyService.showBusyDuring(
          Restangular.one('organizations', org.id).patch(organizationDTO),
        );
      } else {
        schoolDTO = {
          restrictions: that.restrictions,
        };
        BulbBusyService.showBusyDuring(
          Restangular.one('organizations', $scope.topOrg.id).one('schools', org.id).patch(schoolDTO),
        );
      }
    } else if (org.id === $scope.topOrg.id) {
      organizationDTO = {
        gradeRestrictions: that.enabledGrades,
      };

      BulbBusyService.showBusyDuring(
        Restangular.one('organizations', org.id).patch(organizationDTO),
      );
    } else {
      schoolDTO = {
        gradeRestrictions: that.enabledGrades,
      };

      BulbBusyService.showBusyDuring(
        Restangular.one('organizations', $scope.topOrg.id).one('schools', org.id).patch(schoolDTO),
      );
    }
  };

  // We require this listener because the settings page is not generated until after it's been loaded via a click
  // from the Angular Bootstrap Accordion HTML. So we run this just a single time per directive on the page so that
  // it has the most updated values if presented/available.
  $scope.$on('$orgRestrictionsLoaded', () => {
    // We want to make sure this function is only called once per directive, since if this is not here, it will be
    // called every single time a directive is loaded, for all directives.
    if (!that.hasRunLoad) {
      that.hasRunLoad = true;
      $timeout(() => {
        enableCheckboxes($scope.currentRestrictedOrg);
        initialCheckboxDisabling();
      });
    }
  });

  // Change event listener if the grade restrictions have been updated after initial load so it can recalculate
  // which checkboxes need to be checked.
  $scope.$on('$orgRestrictionsChanged', () => {
    $timeout(() => {
      enableCheckboxes($scope.currentRestrictedOrg);
    });
  });
}
